import { Component, Input } from '@angular/core';
import { FlatComplexAttributeValue } from 'src/app/shared/models/attributes/flatAttribute';

@Component({
  selector: 'app-complex-field-viewer',
  templateUrl: './complex-field-viewer.component.html',
  styleUrls: ['./complex-field-viewer.component.scss'],
  standalone: false
})
export class ComplexFieldViewerComponent {
  @Input() complexAttributeValue: FlatComplexAttributeValue;

  constructor() {}
}
